import callApi from "@repo/next-shared/utils/api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { SizeGuideType } from "@/types/sizeguide";

export async function getSizeGuide() {
  return await callApi({ path: "/catalog/sizeguide", method: "GET" });
}

export function useSizeGuideBase(select: any): any {
  return useQuery({
    queryKey: ["size-guide"],
    queryFn: () => getSizeGuide(),
    select,
    staleTime: 60000 * 60,
  });
}

export function useSizeGuide(): UseQueryResult<SizeGuideType[], any> {
  return useSizeGuideBase((sizeguide: SizeGuideType[]) => sizeguide);
}
